// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"3e6fbb8c","372":"b02f3d1e","444":"777d36bf","856":"3b4945f5","864":"7ed8198c"}[chunkId] + ".chunk.js";
};